import { notifyParent } from 'Helpers/notifyParent'
import useRedirectorUrl from 'Hooks/useRedirectorUrl'
import { PageHeader } from 'mailup-web-components'
import { workflowDetails } from 'Pages/Workflow/recoil/state/data'
import { pageState, wizardSteps } from 'Pages/Workflow/recoil/state/page'
import { step2State } from 'Pages/Workflow/recoil/state/step2'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useHistory } from 'react-router'

import { useParams } from 'react-router-dom'
import { useRecoilValue } from 'recoil'

const Header = () => {
  const intl = useIntl()
  const history = useHistory()
  const [redirectUrl] = useRedirectorUrl()

  const { isEditingExistingWorkflow } = useRecoilValue(pageState)
  const { wizardStep } = useRecoilValue(wizardSteps)
  const { Name } = useRecoilValue(workflowDetails)
  const { Name: nameStep2 } = useRecoilValue(step2State)
  const { idWorkflow } = useParams()

  const statusEditLabel = isEditingExistingWorkflow
    ? intl.formatMessage({ id: 'Load.NavMenu.Edit' })
    : intl.formatMessage({ id: 'Load.NavMenu.Create' })
  const breadcrumbsItems = [
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Automation' }),
      'data-mu-test': 'breadcrumb-item__automation',
      className: 'test-breadcrumb-item__automation'
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.AutomationWorkflows' }),
      'data-mu-test': 'breadcrumb-item__automation-workflow',
      className: 'test-breadcrumb-item__automation-workflow',
      url: '#',
      onClick: () => history.push('/automation/workflows/list')
    },
    {
      label: statusEditLabel,
      'data-mu-test': `breadcrumb-item__automation-workflow-${statusEditLabel}`,
      className: `test-breadcrumb-item__automation-workflow-${statusEditLabel}`
    }
  ]

  useEffect(() => {
    if (isEditingExistingWorkflow) {
      notifyParent('selectMenuItemReact', ['UpdateWorkFlow', redirectUrl])
    } else {
      notifyParent('selectMenuItemReact', ['CreateWorkFlow', redirectUrl])
    }
  }, [redirectUrl, isEditingExistingWorkflow])

  return (
    <PageHeader
      breadcrumbsItems={breadcrumbsItems}
      title={
        Name ||
        nameStep2 ||
        (wizardStep === 2 && !idWorkflow) ||
        intl.formatMessage({
          id: 'Load.AutomationWorkflow.AutomationUntitled'
        })
      }
      loading={
        wizardStep === 1 || (!nameStep2 && wizardStep === 2)
          ? false
          : !Name && !nameStep2
      }
    />
  )
}

export default Header
